import { fontFamilies } from "../styles/typography";
import type { ReactNode } from "react";
import { ConfigProvider, theme as antdTheme } from "antd";
import type { Locale } from "antd/es/locale";
import { useTranslation } from "react-i18next";
import { useThemePalette } from "../store/hooks";

// Глобален antd ConfigProvider: преводи за филтрите на таблиците (BG/EN през i18n),
// за да не са на английски. Бутоните се стилизират в index.css (две 50/50 обикновени).
// Тук се превключва и antd тъмната тема (darkAlgorithm) според темата.
export default function ThemedConfig({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  const palette = useThemePalette();
  return (
    <ConfigProvider
      theme={{
        algorithm: palette.isDark
          ? antdTheme.darkAlgorithm
          : antdTheme.defaultAlgorithm,
        // Повърхностите на темата за antd в тъмна тема: базата е платното на
        // приложението, а elevated (модали, dropdown-и, попъпи) е ниво 1 от
        // elevation системата в index.css — иначе antd дава неутрално сиво.
        //
        // `colorPrimary` е АКЦЕНТЪТ на темата (оранжевият в „Оранжево“), не
        // синьото по подразбиране на antd. Без него всяка отметка, radio, активен
        // ред в dropdown и фокус рамка в приложението светваха в #1677ff — цвят,
        // който не съществува никъде другаде в интерфейса. Стойността е същата
        // като `--color-brand` на темата; antd не разбира `var()` в token
        // математиката си, затова идва като hex от lib/themePalettes.ts.
        token: {
          // За разлика от цветовете, antd предава семействата директно в CSS
          // без изчисления: var() свързва и порталите с typography.css.
          fontFamily: fontFamilies.sans,
          fontFamilyCode: fontFamilies.mono,
          colorPrimary: palette.accent,
          colorLink: palette.accentText,
          ...(palette.isDark && palette.elevated
            ? {
                colorBgBase: palette.canvas,
                colorBgContainer: palette.surface,
                colorBgElevated: palette.elevated.surface,
                colorBorder: palette.elevated.border,
                colorBorderSecondary: palette.elevated.borderSecondary,
              }
            : {}),
        },
      }}
      locale={
        {
          Table: {
            filterConfirm: t("inventoryPage.filterApply"),
            filterReset: t("inventoryPage.filterReset"),
            filterSearchPlaceholder: t("inventoryPage.filterSearch"),
            filterCheckAll: t("inventoryPage.filterSelectAll"),
          },
        } as unknown as Locale
      }
    >
      {children}
    </ConfigProvider>
  );
}
